<template>
  <v-layout row wrap justify-center>
    <v-flex xs12>
      <v-subheader>CLASSIFICAÇÃO</v-subheader>
      <div v-if="!n_groups_prop" justify-space-around class="text-xs-center mt-3">
        <v-card>
          <h3>Este campeonato não tem tabela.</h3>
        </v-card>
      </div>
      <v-card
        v-for="(group, index) in n_groups_prop"
        :key="index"
        style="border-radius: 8px"
        class="mb-4"
        v-if="teams_grouped && n_groups_prop"
      >
        <v-card-title primary-title>
          <v-toolbar color="primary" dark style="border-radius: 8px">
            <v-toolbar-title class="white--text">Grupo {{index+1}}</v-toolbar-title>
          </v-toolbar>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="teams_grouped[index]"
          hide-actions
          v-if="headers!='' && headers!=null"
        >
          <template slot="items" slot-scope="props" v-if="props.item.group==index+1">
            <!-- <td>{{ props.item.index }}</td> -->
            <td class="text-xs-center">{{ props.item.team_name }}</td>
            <td class="text-xs-center">{{ props.item.points }}</td>
            <td class="text-xs-center">{{ props.item.won }}</td>
            <td class="text-xs-center">{{ props.item.draw }}</td>
            <td class="text-xs-center">{{ props.item.goals_scored }}</td>
            <td class="text-xs-center">{{ props.item.goals_against }}</td>
            <td class="text-xs-center">{{ props.item.goals_difference }}</td>
          </template>
          <v-alert type="warning" :value="true" slot="no-data">Sem times por equanto</v-alert>
        </v-data-table>
      </v-card>
    </v-flex>

    <card-loading v-if="loading"></card-loading>
  </v-layout>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Api from "../../../api/index";

export default {
  props: {
    champ_teams_aux: {
      type: Array
    },
    n_groups_prop_aux: {
      type: Number,
      default: 4
    }
  },
  data() {
    return {
      champ_teams: null,
      group_config: null,
      n_groups_prop: null,

      loading: false,
      loadText: null,
      headers: [
        // { text: 'Pos.', align: 'left', value: 'position'},
        {
          text: "Equipe",
          align: "center",
          value: "team_name",
          sortable: false
        },
        { align: "center", text: "P", value: "points", sortable: false },
        { align: "center", text: "V", value: "won", sortable: false },
        { align: "center", text: "E", value: "draw", sortable: false },
        { align: "center", text: "GP", value: "goals_scored", sortable: false },
        {
          align: "center",
          text: "GS",
          value: "goals_against",
          sortable: false
        },
        {
          align: "center",
          text: "SG",
          value: "goals_difference",
          sortable: false
        }
      ],
      teams_grouped: null
    };
  },
  computed: {
    ...mapState({})
  },
  methods: {
    getChampTeams(id) {
      Api.Championship.indexChampTeams(id)
        .then(r => r.data)
        .then(data => {
          this.champ_teams = data;
          // console.log({data});
        });
    },
    getGroupConfig(id) {
      Api.Championship.indexGroupConfiguration(id)
        .then(r => r.data)
        .then(data => {
          // console.log({data});
          this.group_config = data[0];
          this.n_groups_prop = data[0].number_groups;
          this.teams_grouped = Array(this.n_groups_prop);
        });
    },
    mapTeams() {
      this.loading = true;
      this.teams_grouped = Array(this.n_groups_prop);
      for (let group = 1; group <= this.n_groups_prop; group++) {
        let the_group = this.champ_teams.filter(obj => obj.group == group);
        this.teams_grouped[group - 1] = the_group.sort((a, b) =>
          a.points > b.points ? -1 : b.points > a.points ? 1 : 0
        );
        console.log(this.teams_grouped);
      }
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    ...mapActions({
      indexChampTeam: "Championship/indexChampTeam"
    })
  },
  watch: {
    champ_teams(nv, ov) {
      if (nv) {
        this.mapTeams();
      } else if (nv == false) {
      }
    }
  },
  mounted() {
    // this.mapTeams();
    this.getChampTeams(this.$route.params.id);
    this.getGroupConfig(this.$route.params.id);
  }
};
</script>

<style scoped>
.CardUser {
  padding: 20px;
}
</style>


